import { produce } from 'immer';
import { DashboardQueuesType } from 'lib-shared-legacy-types';
import { combineActions, handleActions } from 'redux-actions';
import { websocketActions } from '../../../app/middleware/websocket/actions/websocket';
import { dashboardActions } from '../actions/dashboard';
import { apiPathToSearchParams } from '../api/dashboard';
export const { dashboardGetAllQueues, dashboardGetAllQueuesSucceeded, dashboardGetAllQueuesFailed, dashboardGetAgentQueues, dashboardGetAgentQueuesSucceeded, dashboardGetAgentQueuesFailed, dashboardGetQueuesById, dashboardGetQueuesByIdSucceeded, dashboardGetQueuesByIdFailed, dashboardReset, dashboardChangeQueuesType, dashboardWsStatisticsQueueChanged, dashboardGetAllQueuesV1, dashboardGetAllQueuesSucceededV1, dashboardGetAllQueuesFailedV1, dashboardGetAgentQueuesV1, dashboardGetAgentQueuesSucceededV1, dashboardGetAgentQueuesFailedV1, } = dashboardActions;
const DASHBOARD_INITIAL_STATE = {
    meta: {
        ajaxAsyncStatus: 'succeeded',
        wsAsyncStatus: 'succeeded',
        currentPageParams: {
            type: DashboardQueuesType.Agent,
            sort_by: 'name:asc',
        },
        nextPageParams: null,
        prevPageParams: null,
    },
    queues: [],
    personalQueues: [],
    statisticsQueues: [],
};
export const dashboard = handleActions({
    [combineActions(dashboardGetAllQueues, dashboardGetAgentQueues, dashboardGetQueuesById, dashboardGetAllQueuesV1, // v1 reducer
    dashboardGetAgentQueuesV1).toString()]: (state) => {
        return produce(state, (draft) => {
            draft.meta.ajaxAsyncStatus = 'loading';
        });
    },
    [combineActions(dashboardGetAllQueuesFailed, dashboardGetAgentQueuesFailed, dashboardGetQueuesByIdFailed, dashboardGetAllQueuesFailedV1, // v1 reducer
    dashboardGetAgentQueuesFailedV1).toString()]: (state) => {
        return produce(state, (draft) => {
            draft.meta.ajaxAsyncStatus = 'failed';
        });
    },
    [combineActions(dashboardGetAllQueuesSucceeded, dashboardGetAgentQueuesSucceeded).toString()]: (state, action) => {
        const { meta: { currentPageParams: { type }, }, } = state;
        const { data, meta: { next_page, prev_page, current_page }, } = action.payload;
        return produce(state, (draft) => {
            const nextPageParams = next_page
                ? Object.assign(Object.assign({}, apiPathToSearchParams(next_page)), { type })
                : null;
            const prevPageParams = prev_page
                ? Object.assign(Object.assign({}, apiPathToSearchParams(prev_page)), { type })
                : null;
            const currentPageParams = Object.assign(Object.assign({}, (current_page && apiPathToSearchParams(current_page))), { type });
            draft.meta.ajaxAsyncStatus = 'succeeded';
            draft.queues = data.dashboard_entries;
            draft.meta.nextPageParams = nextPageParams;
            draft.meta.prevPageParams = prevPageParams;
            draft.meta.currentPageParams = currentPageParams;
        });
    },
    [dashboardGetQueuesByIdSucceeded.toString()]: (state, action) => {
        return produce(state, (draft) => {
            draft.meta.ajaxAsyncStatus = 'succeeded';
            draft.queues = action.payload.data.dashboard_entries;
            draft.meta.nextPageParams = null;
            draft.meta.prevPageParams = null;
            draft.meta.currentPageParams = {
                type: DashboardQueuesType.Favourite,
                sort_by: state.meta.currentPageParams.sort_by,
            };
        });
    },
    // v1 reducer
    [dashboardGetAllQueuesSucceededV1.toString()]: (state, action) => {
        return produce(state, (draft) => {
            draft.meta.ajaxAsyncStatus = 'succeeded';
            draft.statisticsQueues = action.payload.data.dashboard_entries;
        });
    },
    // v1 reducer
    [dashboardGetAgentQueuesSucceededV1.toString()]: (state, action) => {
        return produce(state, (draft) => {
            draft.meta.ajaxAsyncStatus = 'succeeded';
            draft.personalQueues = action.payload.data.dashboard_entries;
        });
    },
    [dashboardWsStatisticsQueueChanged.toString()]: (state, action) => {
        const { dashboard_entries: updatedQueues } = action.payload.params.dashboard;
        return produce(state, (draft) => {
            updatedQueues.forEach((updatedQueue) => {
                const queueIndex = state.queues.findIndex((queue) => updatedQueue.queue_id === queue.queue_id);
                if (queueIndex > -1) {
                    draft.queues[queueIndex] = updatedQueue;
                }
            });
        });
    },
    [dashboardChangeQueuesType.toString()]: (state, action) => {
        return produce(state, (draft) => {
            draft.meta.currentPageParams = {
                type: action.payload.type,
                sort_by: state.meta.currentPageParams.sort_by,
            };
            draft.meta.nextPageParams = null;
            draft.meta.prevPageParams = null;
            draft.queues = [];
        });
    },
    // WebSocket
    [websocketActions.request.type]: (state) => {
        return produce(state, (draft) => {
            draft.meta.wsAsyncStatus = 'loading';
        });
    },
    [websocketActions.requestFulfilled.type]: (state) => {
        return produce(state, (draft) => {
            draft.meta.wsAsyncStatus = 'succeeded';
        });
    },
    [websocketActions.replyReceived.type]: (state) => {
        return produce(state, (draft) => {
            draft.meta.wsAsyncStatus = 'succeeded';
        });
    },
    [websocketActions.requestRejected.type]: (state) => {
        return produce(state, (draft) => {
            draft.meta.wsAsyncStatus = 'failed';
        });
    },
}, DASHBOARD_INITIAL_STATE);
